import { CallableError } from '../backend/callables';
import { VaultKeyMismatchError, VaultUnreachableError } from '../vault/cloudVault';

/**
 * What failed, said in terms of where the fix is.
 *
 * One message covered a refused fetch, a key that would not open the manifest,
 * and a backend saying no — three problems fixed in three different places,
 * all reading as "could not read the vault".
 */
export function describeFailure(error: unknown): {
  message: string;
  detail: string | null;
  needsRepair: boolean;
} {
  const detail = error instanceof Error ? error.message : null;

  if (error instanceof CallableError) {
    return error.needsRepair
      ? {
          needsRepair: true,
          message: 'This browser is no longer allowed in. Connect it again.',
          detail: null,
        }
      : { needsRepair: false, message: 'The vault refused this read.', detail: `${error.status}: ${detail}` };
  }
  if (error instanceof VaultUnreachableError) {
    return {
      needsRepair: false,
      message: 'The vault is there, but this browser could not fetch it from storage.',
      detail,
    };
  }
  if (error instanceof VaultKeyMismatchError) {
    return {
      needsRepair: false,
      message: 'What is stored did not open with this browser’s key.',
      detail,
    };
  }
  return { needsRepair: false, message: 'Could not read the vault.', detail };
}
